import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';

import { FdkLogoComponent } from '../logo/logo.component';

@Component({
  selector: 'fdk-footer',
  imports: [FdkLogoComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkFooterComponent {}
